var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.div)?_c('div',{staticClass:"error",staticStyle:{"width":"100%","margin-top":"0.25rem","font-size":"0.875em","color":"#dc3545"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_vm._t("default")],2):_c('b-form-invalid-feedback',[_vm._v(" "+_vm._s(_vm.message)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }